import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Loader from 'components/shared/Loader';
import MyForm from 'components/shared/form/MyForm';
import { required, email, phone, maxLength } from 'misc/validations';
import InputField from 'components/shared/form/InputField';
import { getText, trackGA } from 'misc/helpers';
import { SAGA_CUSTOMER_PUT } from 'misc/types';
import SettingsListItem from '../../settings/SettingsListItem';
import * as types from 'misc/types';

class Profile extends Component {
    render = () => {
        const { customer } = this.props;

        return (
            <Loader objectToLoad={customer}>
                {customer.isLoaded && (
                    <div className="settings-view">
                        <h1>{getText('_3_2_TitelProfil', 'Profil')}</h1>

                        <MyForm
                            name="ProfileForm"
                            sagaAction={SAGA_CUSTOMER_PUT}
                            buttonClasses="button-yellow button-medium"
                            submitLabel={getText('_12_0_TextButtonSave', 'Spara')}
                            initialValues={customer.data}
                        >
                            <InputField
                                name="email"
                                type="text"
                                validate={[required, email]}
                                placeholder={getText('ProfileEmail', 'E-postadress')}
                                icon="assets/images/register/ico_email.svg"
                                pending={customer.data.pendingEmail ? true : false}
                            />

                            <InputField
                                name="mobileNumber"
                                type="text"
                                validate={[phone]}
                                maxlength="30"
                                noStartWarning
                                placeholder={getText('_12_0_TextMobilNumber', 'Mobilnummer (frivilligt)')}
                                icon="assets/images/register/ico_mobile.svg"
                                iconClass="register-mobile-icon"
                                pending={false}
                            />
                        </MyForm>

                        {/*
                        {customer.data &&
                            (customer.data.pendingMobileNumber || customer.data.pendingEmail) && (
                                <div className="info-box warning">
                                    <i className="fa fa-exclamation-circle" /> {getText('Missing', 'Dina nya uppgifter behandlas.')}
                                </div>
                            )}
                    */}
                        <p>
                            <small>
                                {getText(
                                    '_12_0_TextCustomerInformation',
                                    'Vi använder dina kontaktuppgifter för att skicka meddelande till dig, om mottagna brev och annan viktig information.'
                                )}
                            </small>
                        </p>
                        <br />
                        <h1>{getText('_3_2_TitelExitServiceAtDigimail', 'Avsluta Digimail')}</h1>

                        <Link to={'end'}>
                            <button className="button-yellow button-big button-bankid">
                                {getText('_6_4_button_ending_digimail', 'Avsluta Digimail')}
                            </button>
                        </Link>
                    </div>
                )}
            </Loader>
        );
    };

    componentDidMount() {
        const { dispatch, sessions } = this.props;
        dispatch({ type: types.SAGA_CUSTOMER_GET.REQUEST, customerId: sessions.data.customerId });

        trackGA('12.0 Profil');
    }
}

// Check if customer has pending email or mobile phone
// and set the appropriate values to the input fields
const mapStateToProps = (state, ownProps) => {
    let customer = state.customer;

    return {
        customer: customer,
        sessions: state.sessions
    };
};

export default connect(mapStateToProps)(Profile);



// WEBPACK FOOTER //
// ./src/components/views/settings/Profile.js